/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Stephan JAMBOU
 * @date        22/04/2022 10:57
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import Footer from '@scripts/components/footer'
import Header from '@scripts/components/header'
import Utils from '@scripts/components/utils'

document.addEventListener('DOMContentLoaded', () => {
    new Utils()
    new Header()
    new Footer()

    if ($('.home').length > 0) {
        import('@scripts/components/home' /* webpackChunkName: "scripts/home" */).then(
            ({ default: Home }) => {
                new Home()
            },
        )
    }
    if ($('.fullscreen').length > 0) {
        import('@scripts/services/layout' /* webpackChunkName: "scripts/layout" */).then(
            ({ default: Layout }) => {
                new Layout()
            },
        )
    }

    //Hide bottom button on roadtrip mobile
    if ($('.wp-block-road-trip').length > 0 && window.matchMedia('(max-width: 1000px)').matches) {
        $('.tools__item--live').hide()
    }
})
